import Vue from 'vue'
import App from './App.vue'
import E4HQuiz from "@/components/E4HQuiz";
import E4HButton from "@/components/E4HButton";

//var jQuery = require( "jquery" );
//import jQuery from 'jquery';

//Vue.config.devtools = true
Vue.config.productionTip = false;

//window.e4h_design="XXDESIGNXX";
//window.e4h_title="XXTITLEXX";

/*
const vues = document.querySelectorAll(".app");
Array.prototype.forEach.call(vues, (el, index) => new Vue({el, data:{message: "hello " + index}}))
 */

const vues = document.querySelectorAll(".e4h-app");
Array.prototype.forEach.call(vues, (elem, index) => {
  let elemDiv = jQuery(elem);
  let bTitle = elemDiv.data('button-title');
  let bDesign = elemDiv.data('button-design');
  new Vue({
    el: elem,
    template:"<app :id='id' :buttondesign='buttondesign' :buttontitle='buttontitle'></app>",
    data:{
      buttontitle: bTitle,
      //id:"e4h-app-" + Math.floor(Math.random() * 1000),
      id: elem.id,
      buttondesign: bDesign
    },
    components:{
      App
    },
    mounted: function() {
    }
  });

});


/*
new Vue({
  el: '.e4h-app',
  template:"<app :id='id' :design='design' :buttontext='buttontext'></app>",
  data:{
    buttontext: window.e4h_title,
    id:"e4h-app-" + Math.floor(Math.random() * 1000),
    design: window.e4h_design
  },
  components:{
    App
  },
  mounted: function() {
    console.log("VUE Mounted!");
    console.log(jQuery('.e4h-app'));
    console.log(this.$el);
  }
});
*/

/*
new Vue({
  render: h => h(App, {
    props: {
      'design': 'primary'
    }
  }),
}).$mount('#e4h-app')
*/
